import { useEffect } from "react";

// When this is in the tree, it will ensure that the page is scrolled
// to the top on mount.
// For more context see https://reactrouter.com/web/guides/scroll-restoration and
// https://stackoverflow.com/questions/33188994/scroll-to-the-top-of-the-page-after-render-in-react-js
function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
}

export default ScrollToTopOnMount;
